import styled, { css } from 'styled-components';
import { baseButtonStyles } from '../Button/styles.js';
import { contentTextPropExclusions, contentTextStyles } from '../ContentText/styles.web.js';
import { px2rem } from '../utils/helpers/style.js';
import { spacing } from '../constants/spacing.js';
import { styles } from '../constants/styles.js';
import { fontWeights } from '../constants/font-weights.js';
import { generateColorLuminances } from '../utils/helpers/generateColorLuminances.js';

var button = /*#__PURE__*/styled.button.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !contentTextPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__button",
  componentId: "sc-1vazozn-0"
})(["", " ", " font-size:", ";height:", ";padding-left:", ";padding-right:", ";border-radius:", ";margin-left:", ";margin-right:", ";"], baseButtonStyles, contentTextStyles, function (p) {
  return p.theme.datebrowser.web.fontSize;
}, function (p) {
  return p.theme.datebrowser.web.sizings[p.$size].height;
}, spacing.xxs, spacing.xxs, function (p) {
  return p.theme.datebrowser.web.trigger.borderRadius;
}, spacing.xxxs, spacing.xxxs);
var yearItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "styles__yearItem",
  componentId: "sc-1vazozn-1"
})(["transition:background ", ",color ", ";height:", ";font-size:", ";display:inline-flex;align-items:center;justify-content:center;font-weight:", ";background:", ";color:", ";&:hover{background:", ";color:", ";}padding-left:", ";padding-right:", ";white-space:nowrap;min-width:min-content;cursor:pointer;"], styles.transition.timing.base, styles.transition.timing.base, px2rem(56), px2rem(18), function (p) {
  return p.selected ? fontWeights.medium : fontWeights.light;
}, function (p) {
  return p.selected ? p.color : undefined;
}, function (p) {
  return p.selected ? generateColorLuminances('normal', p.theme, {
    color: p.color
  }).fg : undefined;
}, function (p) {
  return p.selected ? generateColorLuminances('hover', p.theme, {
    color: p.color
  }).bg : p.theme.datepicker.web.items.hover;
}, function (p) {
  return p.selected ? generateColorLuminances('hover', p.theme, {
    color: p.color
  }).fg : undefined;
}, spacing.s, spacing.s);
var yearContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__yearContainer",
  componentId: "sc-1vazozn-2"
})(["max-height:", ";overflow:auto;width:100%;&::-webkit-scrollbar{background:", ";width:", ";}&::-webkit-scrollbar-track{background:", ";box-shadow:none;}&::-webkit-scrollbar-thumb{background-color:", ";border:", " solid ", ";box-shadow:none;}scrollbar-width:thin;", ";"], function (p) {
  return px2rem(56 * p.$displayedItems);
}, function (props) {
  return props.theme.listItems.web.background;
}, px2rem(8), function (props) {
  return props.theme.listItems.web.background;
}, function (props) {
  return props.color ? props.color : props.theme.listItems.web.color;
}, px2rem(2), function (props) {
  return props.theme.listItems.web.background;
}, function (props) {
  return css(["scrollbar-color:", " ", ""], props.color ? props.color : props.theme.listItems.web.color, props.theme.listItems.web.background);
});

export { button, yearContainer, yearItem };
